import { SearchDuration } from "@apply4u/models/search/search-duration";

export const SearchDurations: SearchDuration[] = [
    { Id: -1, Description: "Search within last" },
    { Id: 0, Description: "All" },
    { Id: 1, Description: "24 hours" },
    { Id: 2, Description: "48 hours" },
    { Id: 3, Description: "72 hours" },
    { Id: 7, Description: "1 week" },
    { Id: 14, Description: "2 weeks" },
    { Id: 30, Description: "1 month" },
    { Id: 90, Description: "3 months" },
    { Id: 180, Description: "6 months" },
    { Id: 365, Description: "1 year" }
];